import * as THREE from "three";

/** World-space aggregate and worn tracks stay attached to the terrain, including instanced ground. */
export function fieldSurface(color: number, road: boolean | "yard" = false): THREE.MeshStandardMaterial {
  const material = new THREE.MeshStandardMaterial({
    color,
    roughness: 0.96,
    metalness: 0,
    vertexColors: road === false,
  });
  material.customProgramCacheKey = () => `field-surface-${road === "yard" ? "yard" : road ? "road" : "soil"}-3`;
  material.onBeforeCompile = (shader) => {
    shader.vertexShader = shader.vertexShader
      .replace("#include <common>", "#include <common>\nvarying vec3 vFieldPosition;")
      .replace(
        "#include <project_vertex>",
        "#include <project_vertex>\nvec4 fieldPoint=vec4(transformed,1.0);\n#ifdef USE_INSTANCING\nfieldPoint=instanceMatrix*fieldPoint;\n#endif\nvFieldPosition=(modelMatrix*fieldPoint).xyz;",
      );
    shader.fragmentShader = shader.fragmentShader
      .replace(
        "#include <common>",
        `#include <common>
      varying vec3 vFieldPosition;
      float fieldHash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
      float fieldNoise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.0-2.0*f);return mix(mix(fieldHash(i),fieldHash(i+vec2(1,0)),f.x),mix(fieldHash(i+vec2(0,1)),fieldHash(i+vec2(1,1)),f.x),f.y);}
    `,
      )
      .replace(
        "#include <color_fragment>",
        `#include <color_fragment>
      vec2 fieldUV=vFieldPosition.xz;
      float grit=fieldNoise(fieldUV*55.0),soilPatch=fieldNoise(fieldUV*.7),grain=fieldNoise(fieldUV*9.0);
      diffuseColor.rgb*=.69+grit*.19+grain*.16+soilPatch*.24;
      ${
        road === "yard"
          ? `float grass= smoothstep(.38,.7,fieldNoise(fieldUV*.24)+fieldNoise(fieldUV*.83)*.18);
        diffuseColor.rgb=mix(diffuseColor.rgb, diffuseColor.rgb*vec3(.66,.81,.47),grass);
        float pebbles=step(.88,fieldNoise(fieldUV*32.0));
        diffuseColor.rgb+=pebbles*.023;`
          : road
          ? `float scar=abs(sin(fieldUV.x*1.5+fieldNoise(fieldUV*.8)*5.0+fieldUV.y*.3));
        diffuseColor.rgb*=1.0-.32*(1.0-smoothstep(.015,.05,scar));`
          : `float track=abs(sin(fieldUV.y*.13+sin(fieldUV.x*.055)*.5));
        float worn=1.0-smoothstep(.025,.05,track);
        diffuseColor.rgb=mix(diffuseColor.rgb,vec3(.22,.18,.115)*(0.8+grain*.25),worn*.6);`
      }
    `,
      );
  };
  return material;
}
